// apiMiddleware.js
import { setAccessToken, setUser } from './store';
import authManager from './authManager'; // Import the singleton instance

const apiMiddleware = ({ dispatch, getState }) => (next) => async (action) => {
  if (action.type !== 'API_CALL') return next(action);

  const { url, method, onStart, onSuccess, onError, authRequired, authOptional, query, body, fileUpload } = action.meta;

  const queryString = query ? `?${query}` : '';

  // Start the API call if specified
  if (onStart) dispatch({ type: onStart });

  // Wait for the authManager's authPromise to resolve
  if (authRequired || authOptional) {
    await authManager.authPromise;
  }

  const { accessToken } = getState();

  if (authRequired) {
    if (!accessToken) {
      console.log("No access token");
      return;
    }
  }

  const headers = {
    'Accept': 'application/json',
    ...(fileUpload ? {} : { 'Content-Type': 'application/json' }),
    ...((authRequired || authOptional) && accessToken ? { Authorization: `${accessToken}` } : {}),
  };

  try {
    const response = await fetch(window.backendUrl + url + queryString, { method, headers, body });
    var errorJson = null;
    
    if (response.status === 401) {
      // Refresh token logic
      const refreshSuccess = await authManager.refreshUserToken;
      if (refreshSuccess) {
        // Retry original request
        const retryResponse = await fetch(window.backendUrl + url + queryString, { method, headers: { ...headers, Authorization: `${getState().accessToken}` }, body });
        if (!retryResponse.ok) throw new Error('Retry request failed');
        const data = await retryResponse.json();
        if (onSuccess) dispatch({ type: onSuccess, payload: data });
        return;
      } else {
        // Log out user if refresh fails
        dispatch(setUser(null));
        dispatch(setAccessToken(null));
      }
    } else if (!response.ok) {
      // Pass error json response if not ok if it is json
      try {
        errorJson = await response.json();
        throw new Error('Request failed');
      } catch (error) {
        throw new Error('Request failed');
      }
    } else {
      const data = await response.json();
      if (onSuccess) dispatch({ type: onSuccess, payload: data });
    }
  } catch (error) {
    if (onError) dispatch({ type: onError, error: (errorJson ? errorJson : error.message) });
  }
};

export default apiMiddleware;
